import { Grid } from '@material-ui/core'
import { AsterToggleButton, AsterToggleButtonGroup } from 'asterX-UI/Buttons/toggle-button'
import React, { useEffect, useState } from 'react'
import { ContentCard } from 'components/ContentCard/ContentCard'
import { useContractStore } from 'context/ContractStore'
import { geFinanceData, financeTableTypes } from './const'
import { useStyles } from './finance-information.styles'
import { FinanceTable } from './components/FinanceTable'

export const FinanceInformation = () => {
  const classes = useStyles()

  const {
    contractStore: { contract, contractAll }
  } = useContractStore()

  const [activeTab, setActiveTab] = useState('overdueTranches')

  useEffect(() => {
    if (contractAll.workListStatusCode === 'COMPLETED') {
      setActiveTab('payments')
    }
  }, [contractAll.workListStatusCode])

  return (
    <Grid container className={classes.wrapper}>
      <Grid item container>
        <ContentCard data={geFinanceData(contract)} line />
      </Grid>
      <Grid item container className={classes.tableFilter}>
        <AsterToggleButtonGroup
          exclusive
          value={activeTab}
          onChange={(e, val) => {
            setActiveTab(val)
          }}
        >
          {financeTableTypes
            .filter(({ code }) => {
              if (contractAll.workListStatusCode === 'COMPLETED') {
                return code !== 'paymentSchedule' && code !== 'overdueTranches'
              }
              return true
            })
            .map(({ label, code }) => (
              <AsterToggleButton key={`table-toggle-btn-${code}`} value={code}>
                {label}
              </AsterToggleButton>
            ))}
        </AsterToggleButtonGroup>
      </Grid>

      <Grid item container>
        <FinanceTable tableType={activeTab} contract={contract} />
      </Grid>
    </Grid>
  )
}
